export const canvasUtils = {
    createCanvas: (width: number, height: number): HTMLCanvasElement => {
        const canvas = document.createElement('canvas');

        canvas.width = width;
        canvas.height = height;

        return canvas;
    },

    drawRoundRect: (ctx: CanvasRenderingContext2D, x: number, y: number, width: number, height: number,
        radius = 0, drawFill = true, drawStroke = false): void => {
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();

        if (drawStroke) {
            ctx.stroke();
        }

        if (drawFill) {
            ctx.fill();
        }
    }
};